import React from "react";
import { Form, Input, DatePicker, Checkbox, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";

const ScheduleRuleItem = ({ fieldKey, name, restField, rule }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={[12, 12]} key={fieldKey}>
      <Form.Item
        {...restField}
        name={[name, "cleaning_service_group_id"]}
        hidden
      >
        <Input />
      </Form.Item>
      <Form.Item
        {...restField}
        name={[name, "buildingUnitId"]}
        hidden
      >
        <Input />
      </Form.Item>
      <Form.Item
        {...restField}
        name={[name, "uniqueId"]}
        hidden
      >
        <Input />
      </Form.Item>

      <Col span={10}>
        <Form.Item {...restField} name={[name, "buildingUnitAddress"]}>
          <Input disabled style={{ fontSize: "12px" }} />
        </Form.Item>
      </Col>

      <Col span={6}>
        <Form.Item {...restField} name={[name, "name"]}>
          <Input placeholder={t("schedules.frequancy")} disabled />
        </Form.Item>
      </Col>
      
      <Col span={5}>
        <Form.Item
          {...restField}
          name={[name, "date_from"]}
          rules={[{ required: true, message: t("schedules.validation.dateRequired") }]}
        >
          <DatePicker
            format="YYYY-MM-DD"
            placeholder={t("schedules.firstCleaning")}
            style={{ width: "100%" }}
            allowClear={false}
            picker="date"
            disabledDate={(current) => {
              return current && current.day() !== 1; // Only Mondays
            }}
            defaultValue={moment().startOf('isoWeek')}
          />
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item
          {...restField}
          name={[name, "freeGeneralCleaning"]}
          valuePropName="checked"
          style={{ marginBottom: 0 }}
        >
          <Checkbox />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default ScheduleRuleItem;
